// extracted by mini-css-extract-plugin
export default {"splashScreen":"SplashScreen_splashScreen__QwuBC","loader":"SplashScreen_loader__aJt5F"};